/* eslint-disable arrow-body-style */
import { createSelector } from '@ngrx/store';
import * as appSelectors from './app.selectors';
import * as fromReducer from '../reducers';
import * as Types from '../modals';

export const selectFollowUpState = createSelector(
  appSelectors.selectApp,
  (appState: fromReducer.AppStateI): Types.FollowUpStateI => appState.followUp,
);

export const selectFollowUp = createSelector(
  selectFollowUpState,
  (state: Types.FollowUpStateI): Record<string, any> | null => state.pendingFollowup,
);

export const selectFollowUpLoading = createSelector(
  selectFollowUpState,
  (state: Types.FollowUpStateI): boolean => state.isLoading,
);

export const selectFollowUpHasFetched = createSelector(
  selectFollowUpState,
  (state: Types.FollowUpStateI): boolean => state.hasFetched,
);
